import MFormActionButtons from './index.vue';

MFormActionButtons.install = app => {
  app.component(MFormActionButtons.name, MFormActionButtons);
};

export default MFormActionButtons;
